import { ChangeDetectionStrategy, Component, computed, inject, input, ViewEncapsulation } from '@angular/core';
import { ISectionBlock } from './section.model';
import { KameleoonService } from '@seven1/angular/kameleoon';
import { ActivatedRoute } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { CmsComponent } from '@seven1/angular-storyblok-cms';
import { ENVIRONMENT } from '@seven1/angular-storyblok/environment';

@Component({
    selector: 'section[s1-section]',
    imports: [CmsComponent],
    templateUrl: './section.component.html',
    styleUrl: './section.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 's1-section',
        '[class]': 'classes()',
        '[class.!hidden]': '!visible()',
        '[attr.id]': 'block().componentId',
    }
})
export class SectionComponent {
    private _route = inject(ActivatedRoute);
    private _kameleoon = inject(KameleoonService);
    private _queryParams = toSignal(this._route.queryParamMap);
    private _tailwind = inject(TailwindService);
    env = inject(ENVIRONMENT);


    block = input.required<ISectionBlock>();

    classes = computed(() => {
        const block = this.block();
        const classes = [
            ...this._tailwind.getSpacingClasses(block),
            ...this._tailwind.getBackgroundColorClasses(block),
            ...this._tailwind.getDisplayClasses(block)
        ];
        if (block.limitedWidth) {
            classes.push('s1-section--limited-width')
        }
        return classes;
    });

    visible = computed(() => {
        return this._kameleoon.visible(this._queryParams(), this.block());
    });
}
